import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import useAuth from "./useAuth";
import { BASE_URL } from "./Constants";
import logo from "./images/logo.png";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Upload_New = () => {
  const [assessments, setAssessments] = useState([]);
  const [assessmentLoading, setAssessmentLoading] = useState(false);

  // Filters
  const [deptFilter, setDeptFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useAuth();

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchAssessment();
  }, []);

  const fetchAssessment = async () => {
    try {
      setAssessmentLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await fetch(`${BASE_URL}get_assessment`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status) {
        setAssessments(result.data || []);
      }
    } catch (err) {
      console.error("Assessment fetch error:", err);
    } finally {
      setAssessmentLoading(false);
    }
  };

  /* ================= FILTER ================= */
  const uniqueDepartments = [
    ...new Set(assessments.map((a) => a.dept_name)),
  ];

  const uniqueLocations = [
    ...new Set(assessments.map((a) => a.location_name)),
  ];

  const filteredAssessments = assessments.filter((item) => {
    const matchDept = !deptFilter || item.dept_name === deptFilter;
    const matchLocation =
      !locationFilter || item.location_name === locationFilter;
    const matchDate =
      !dateFilter || item.created_on?.slice(0, 10) === dateFilter;

    return matchDept && matchLocation && matchDate;
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [deptFilter, locationFilter, dateFilter]);

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(
    filteredAssessments.length / rowsPerPage
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentRows = filteredAssessments.slice(
    indexOfFirstRow,
    indexOfLastRow
  );

  const downloadExcel = () => {

    if (!filteredAssessments.length) {
      alert("No data available");
      return;
    }

    // ✅ Format Excel Data
    const excelData = filteredAssessments.map((item, index) => ({
      "S.No": index + 1,
      "Employee ID": item.emp_id,
      "Department": item.dept_name,
      "Location": item.location_name,
      "Viva Marks": item.viva_total_marks,
      "Percentage": item.percentage,
      "Assessment Date": item.created_on
        ? new Date(item.created_on).toLocaleString()
        : "-"
    }));

    // ✅ Sheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // ✅ Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Assessments");

    // ✅ Auto width (professional look)
    worksheet["!cols"] = [
      { wch: 8 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 12 },
      { wch: 12 },
      { wch: 25 },
    ];

    // ✅ File generate
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      fileData,
      `Assessment_Report_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  const totalCompletedAssessments = filteredAssessments.length;

  const visiblePageCount = 5;

let startPage = Math.max(
  1,
  currentPage - Math.floor(visiblePageCount / 2)
);

let endPage = startPage + visiblePageCount - 1;

if (endPage > totalPages) {
  endPage = totalPages;
  startPage = Math.max(1, endPage - visiblePageCount + 1);
}

const visiblePages = [];
for (let i = startPage; i <= endPage; i++) {
  visiblePages.push(i);
}

  /* ================= UI ================= */
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">

            {/* Welcome */}
            <div className="card text-center p-4 mb-4"
              style={{
                borderRadius: "12px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
              }}>
              <h2 style={{ fontWeight: 700, color: "#2c3e50" }}>
                Welcome to Vijaya Diagnostic Centre
              </h2>

              <img
                src={logo}
                alt="logo"
                style={{
                  width: "320px",
                  maxWidth: "80%",
                  margin: "20px auto",
                }}
              />
            </div>

            {/* ===== SIDE BY SIDE SECTION ===== */}
            <div className="row">

              <div className="mb-3">
  <label style={{fontWeight:"bold"}}>Filter by Location:</label>

  <div className="d-flex flex-wrap gap-2 mt-2">

    <button
      className={`btn btn-sm ${
        locationFilter === "" ? "btn-primary" : "btn-outline-primary"
      }`}
      onClick={() => setLocationFilter("")}
    >
      All
    </button>

    {uniqueLocations.map((loc, i) => (
      <button
        key={i}
        className={`btn btn-sm ${
          locationFilter === loc
            ? "btn-primary"
            : "btn-outline-primary"
        }`}
        onClick={() => setLocationFilter(loc)}
      >
        {loc}
      </button>
    ))}

  </div>
</div>

              {/* LEFT SUMMARY CARD */}
              {/* <div className="col-md-3 mb-4">
                <div
                  className="card text-white h-100"
                  style={{
                    background:
                      "linear-gradient(135deg,#4B49AC,#6a67ce)",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  <div className="card-body d-flex flex-column justify-content-center text-center">
                    <h6>Total Completed Assessments</h6>
                    <h1 style={{ fontWeight: 700 }}>
                      {totalCompletedAssessments}
                    </h1>
                  </div>
                </div>
              </div> */}

              {/* RIGHT TABLE */}
              <div className="col-md-12">
                <div className="card shadow-sm">
                  <div className="card-body">

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 style={{ marginBottom: 0 }}>
                        Assessment Details
                      </h4>

                      <button
                        className="btn btn-success"
                        onClick={downloadExcel}
                      >
                        ⬇ Download Excel
                      </button>
                    </div>

                    {/* Filters */}
                    <div className="row mb-3 align-items-end">
                      {/* ✅ TOTAL COUNT BESIDE DEPARTMENT */}
                      <div className="col-md-3">
                        <label>Total Assessments Completed</label>
                        <div
                          style={{
                            background: "#4B49AC",
                            color: "#fff",
                            padding: "8px 12px",
                            borderRadius: "6px",
                            fontWeight: "bold",
                            textAlign: "center"
                          }}
                        >
                          {totalCompletedAssessments}
                        </div>
                      </div>
                      {/* Department */}
                      <div className="col-md-3">
                        <label>Department</label>
                        <select
                          className="form-control"
                          value={deptFilter}
                          onChange={(e) => setDeptFilter(e.target.value)}
                        >
                          <option value="">All</option>
                          {uniqueDepartments.map((dept, i) => (
                            <option key={i}>{dept}</option>
                          ))}
                        </select>
                      </div>



                      {/* Location */}
                      <div className="col-md-3">
                        <label>Location</label>
                        <select
                          className="form-control"
                          value={locationFilter}
                          onChange={(e) => setLocationFilter(e.target.value)}
                        >
                          <option value="">All</option>
                          {uniqueLocations.map((loc, i) => (
                            <option key={i}>{loc}</option>
                          ))}
                        </select>
                      </div>

                      {/* Date */}
                      <div className="col-md-3">
                        <label>Assessment Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={dateFilter}
                          onChange={(e) => setDateFilter(e.target.value)}
                        />
                      </div>

                    </div>

                    {/* Table */}
                    {assessmentLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <>
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead
                              style={{
                                backgroundColor: "#4B49AC",
                                color: "#fff",
                              }}
                            >
                              <tr>
                                <th>Employee ID</th>
                                <th>Department</th>
                                <th>Location</th>
                                <th>Viva Marks</th>
                                <th>Percentage</th>
                                <th>Assessment Date</th>
                              </tr>
                            </thead>

                            <tbody>
                              {currentRows.map((item, i) => (
                                <tr key={i}>
                                  <td>{item.emp_id}</td>
                                  <td>{item.dept_name}</td>
                                  <td>{item.location_name}</td>
                                  <td>{item.viva_total_marks}</td>
                                  <td>{item.percentage}</td>
                                  <td>
                                    {item.created_on
                                      ? new Date(
                                        item.created_on
                                      ).toLocaleString()
                                      : "-"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        {totalPages > 1 && (
                          <div className="d-flex justify-content-center mt-3 gap-2">

  {/* PREVIOUS ARROW */}
  <button
    className="btn btn-sm btn-secondary"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(p => p - 1)}
  >
    ◀
  </button>

  {/* PAGE NUMBERS (ONLY 5) */}
  {visiblePages.map((page) => (
    <button
      key={page}
      className={`btn btn-sm ${
        currentPage === page
          ? "btn-primary"
          : "btn-outline-primary"
      }`}
      onClick={() => setCurrentPage(page)}
    >
      {page}
    </button>
  ))}

  {/* NEXT ARROW */}
  <button
    className="btn btn-sm btn-secondary"
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage(p => p + 1)}
  >
    ▶
  </button>

</div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer className="footer">
            © {new Date().getFullYear()} Vijaya Diagnostic Centre
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Upload_New;